// language=GraphQL
export const ALL_FIELD_VISIBILITY_CONFIGS_QUERY = `query Query($withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsDatesAvailabilityStatus: Boolean = false, $withPricingTravelsDatesExtensionBaseDate: Boolean = false, $withPricingTravelsDatesExtension: Boolean = false, $withPricingTravelsDatesPackageSettings: Boolean = false, $withPricingTravelsDatesExtensions: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsAccommodationsCapacitySettings: Boolean = false, $withPricingTravelsAccommodationsAddons: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsFamilyPackagesAccommodation: Boolean = false, $withPricingTravelsFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelsFamilyPackagesAddons: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelsPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelsPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelsBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsExtensionsTravelExtension: Boolean = false, $withPricingTravelsExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingTravelsPersonalDiscountsMandatorySettings: Boolean = false) {
  fieldVisibilityConfigs: customBookingFormFieldVisibilityConfigs {
    id
    pricingTravels @include(if: $withPricingTravels) {
      id
      ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {
        id
        catalogCode
        travelCode
        json
      }
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      dates @include(if: $withPricingTravelsDates) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withPricingTravelsDatesAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        includesExtension
        extensionBaseDate @include(if: $withPricingTravelsDatesExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
        extension @include(if: $withPricingTravelsDatesExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withPricingTravelsDatesPackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withPricingTravelsDatesExtensions) {
          id
          label
          info
        }
      }
      accommodations @include(if: $withPricingTravelsAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withPricingTravelsAccommodationsCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withPricingTravelsAccommodationsAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        extensionAccommodationServiceNo
      }
      familyPackages @include(if: $withPricingTravelsFamilyPackages) {
        id
        ratioServiceNo
        accommodation @include(if: $withPricingTravelsFamilyPackagesAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        name
        label
        info
        capacitySettings @include(if: $withPricingTravelsFamilyPackagesCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withPricingTravelsFamilyPackagesAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      personalAddons @include(if: $withPricingTravelsPersonalAddons) {
        id
        ratioServiceNo
        name
        label
        info
        allowedAgeGroups @include(if: $withPricingTravelsPersonalAddonsAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        calculationSettings @include(if: $withPricingTravelsPersonalAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelsPersonalAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withPricingTravelsAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelsAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      bookingAddons @include(if: $withPricingTravelsBookingAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withPricingTravelsBookingAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelsBookingAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {
        id
        label
        info
        ageGroupServices @include(if: $withPricingTravelsCollectiveAddonsAgeGroupServices) {
          id
          ratioServiceNo
        }
        calculationSettings @include(if: $withPricingTravelsCollectiveAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelsCollectiveAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      extensions @include(if: $withPricingTravelsExtensions) {
        id
        label
        info
        travelExtension @include(if: $withPricingTravelsExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withPricingTravelsExtensionsAccommodationMapItems) {
          id
        }
      }
      personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {
        id
        ratioServiceNo
        name
        label
        info
        mandatorySettings @include(if: $withPricingTravelsPersonalDiscountsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      importDateTime
      importStatus
    }
  }
}`

// language=GraphQL
export const SINGLE_FIELD_VISIBILITY_CONFIG_QUERY = `query Query($id: ID!, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsDatesAvailabilityStatus: Boolean = false, $withPricingTravelsDatesExtensionBaseDate: Boolean = false, $withPricingTravelsDatesExtension: Boolean = false, $withPricingTravelsDatesPackageSettings: Boolean = false, $withPricingTravelsDatesExtensions: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsAccommodationsCapacitySettings: Boolean = false, $withPricingTravelsAccommodationsAddons: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsFamilyPackagesAccommodation: Boolean = false, $withPricingTravelsFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelsFamilyPackagesAddons: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelsPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelsPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelsBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsExtensionsTravelExtension: Boolean = false, $withPricingTravelsExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingTravelsPersonalDiscountsMandatorySettings: Boolean = false) {
  fieldVisibilityConfig: customBookingFormFieldVisibilityConfig(id: $id) {
    id
    pricingTravels @include(if: $withPricingTravels) {
      id
      ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {
        id
        catalogCode
        travelCode
        json
      }
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      dates @include(if: $withPricingTravelsDates) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withPricingTravelsDatesAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        includesExtension
        extensionBaseDate @include(if: $withPricingTravelsDatesExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
        extension @include(if: $withPricingTravelsDatesExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withPricingTravelsDatesPackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withPricingTravelsDatesExtensions) {
          id
          label
          info
        }
      }
      accommodations @include(if: $withPricingTravelsAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withPricingTravelsAccommodationsCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withPricingTravelsAccommodationsAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        extensionAccommodationServiceNo
      }
      familyPackages @include(if: $withPricingTravelsFamilyPackages) {
        id
        ratioServiceNo
        accommodation @include(if: $withPricingTravelsFamilyPackagesAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        name
        label
        info
        capacitySettings @include(if: $withPricingTravelsFamilyPackagesCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withPricingTravelsFamilyPackagesAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      personalAddons @include(if: $withPricingTravelsPersonalAddons) {
        id
        ratioServiceNo
        name
        label
        info
        allowedAgeGroups @include(if: $withPricingTravelsPersonalAddonsAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        calculationSettings @include(if: $withPricingTravelsPersonalAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelsPersonalAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withPricingTravelsAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelsAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      bookingAddons @include(if: $withPricingTravelsBookingAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withPricingTravelsBookingAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelsBookingAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {
        id
        label
        info
        ageGroupServices @include(if: $withPricingTravelsCollectiveAddonsAgeGroupServices) {
          id
          ratioServiceNo
        }
        calculationSettings @include(if: $withPricingTravelsCollectiveAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelsCollectiveAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      extensions @include(if: $withPricingTravelsExtensions) {
        id
        label
        info
        travelExtension @include(if: $withPricingTravelsExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withPricingTravelsExtensionsAccommodationMapItems) {
          id
        }
      }
      personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {
        id
        ratioServiceNo
        name
        label
        info
        mandatorySettings @include(if: $withPricingTravelsPersonalDiscountsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      importDateTime
      importStatus
    }
  }
}`

// language=GraphQL
export const CREATE_FIELD_VISIBILITY_CONFIG_MUTATION = `
  mutation Mutation($input: CreateCustomBookingFormFieldVisibilityConfigInput, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsDatesAvailabilityStatus: Boolean = false, $withPricingTravelsDatesExtensionBaseDate: Boolean = false, $withPricingTravelsDatesExtension: Boolean = false, $withPricingTravelsDatesPackageSettings: Boolean = false, $withPricingTravelsDatesExtensions: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsAccommodationsCapacitySettings: Boolean = false, $withPricingTravelsAccommodationsAddons: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsFamilyPackagesAccommodation: Boolean = false, $withPricingTravelsFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelsFamilyPackagesAddons: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelsPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelsPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelsBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsExtensionsTravelExtension: Boolean = false, $withPricingTravelsExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingTravelsPersonalDiscountsMandatorySettings: Boolean = false) {
    fieldVisibilityConfig: createCustomBookingFormFieldVisibilityConfig(input: $input) {
      id
      pricingTravels @include(if: $withPricingTravels) {
        id
        ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {
          id
          catalogCode
          travelCode
          json
        }
        catalogCode
        travelCode
        destination
        name
        transportType
        transportTypeLabel
        dates @include(if: $withPricingTravelsDates) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withPricingTravelsDatesAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          includesExtension
          extensionBaseDate @include(if: $withPricingTravelsDatesExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
          extension @include(if: $withPricingTravelsDatesExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withPricingTravelsDatesPackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withPricingTravelsDatesExtensions) {
            id
            label
            info
          }
        }
        accommodations @include(if: $withPricingTravelsAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withPricingTravelsAccommodationsCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withPricingTravelsAccommodationsAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
        familyPackages @include(if: $withPricingTravelsFamilyPackages) {
          id
          ratioServiceNo
          accommodation @include(if: $withPricingTravelsFamilyPackagesAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          name
          label
          info
          capacitySettings @include(if: $withPricingTravelsFamilyPackagesCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withPricingTravelsFamilyPackagesAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        personalAddons @include(if: $withPricingTravelsPersonalAddons) {
          id
          ratioServiceNo
          name
          label
          info
          allowedAgeGroups @include(if: $withPricingTravelsPersonalAddonsAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          calculationSettings @include(if: $withPricingTravelsPersonalAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelsPersonalAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withPricingTravelsAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelsAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        bookingAddons @include(if: $withPricingTravelsBookingAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withPricingTravelsBookingAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelsBookingAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {
          id
          label
          info
          ageGroupServices @include(if: $withPricingTravelsCollectiveAddonsAgeGroupServices) {
            id
            ratioServiceNo
          }
          calculationSettings @include(if: $withPricingTravelsCollectiveAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelsCollectiveAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        extensions @include(if: $withPricingTravelsExtensions) {
          id
          label
          info
          travelExtension @include(if: $withPricingTravelsExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withPricingTravelsExtensionsAccommodationMapItems) {
            id
          }
        }
        personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
          mandatorySettings @include(if: $withPricingTravelsPersonalDiscountsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        importDateTime
        importStatus
      }
    }
  }`

// language=GraphQL
export const UPDATE_FIELD_VISIBILITY_CONFIG_MUTATION = `
  mutation Mutation($input: UpdateCustomBookingFormFieldVisibilityConfigInput, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsDatesAvailabilityStatus: Boolean = false, $withPricingTravelsDatesExtensionBaseDate: Boolean = false, $withPricingTravelsDatesExtension: Boolean = false, $withPricingTravelsDatesPackageSettings: Boolean = false, $withPricingTravelsDatesExtensions: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsAccommodationsCapacitySettings: Boolean = false, $withPricingTravelsAccommodationsAddons: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsFamilyPackagesAccommodation: Boolean = false, $withPricingTravelsFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelsFamilyPackagesAddons: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelsPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelsPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelsBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsExtensionsTravelExtension: Boolean = false, $withPricingTravelsExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingTravelsPersonalDiscountsMandatorySettings: Boolean = false) {
    fieldVisibilityConfig: updateCustomBookingFormFieldVisibilityConfig(input: $input) {
      id
      pricingTravels @include(if: $withPricingTravels) {
        id
        ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {
          id
          catalogCode
          travelCode
          json
        }
        catalogCode
        travelCode
        destination
        name
        transportType
        transportTypeLabel
        dates @include(if: $withPricingTravelsDates) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withPricingTravelsDatesAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          includesExtension
          extensionBaseDate @include(if: $withPricingTravelsDatesExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
          extension @include(if: $withPricingTravelsDatesExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withPricingTravelsDatesPackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withPricingTravelsDatesExtensions) {
            id
            label
            info
          }
        }
        accommodations @include(if: $withPricingTravelsAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withPricingTravelsAccommodationsCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withPricingTravelsAccommodationsAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
        familyPackages @include(if: $withPricingTravelsFamilyPackages) {
          id
          ratioServiceNo
          accommodation @include(if: $withPricingTravelsFamilyPackagesAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          name
          label
          info
          capacitySettings @include(if: $withPricingTravelsFamilyPackagesCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withPricingTravelsFamilyPackagesAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        personalAddons @include(if: $withPricingTravelsPersonalAddons) {
          id
          ratioServiceNo
          name
          label
          info
          allowedAgeGroups @include(if: $withPricingTravelsPersonalAddonsAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          calculationSettings @include(if: $withPricingTravelsPersonalAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelsPersonalAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withPricingTravelsAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelsAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        bookingAddons @include(if: $withPricingTravelsBookingAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withPricingTravelsBookingAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelsBookingAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {
          id
          label
          info
          ageGroupServices @include(if: $withPricingTravelsCollectiveAddonsAgeGroupServices) {
            id
            ratioServiceNo
          }
          calculationSettings @include(if: $withPricingTravelsCollectiveAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelsCollectiveAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        extensions @include(if: $withPricingTravelsExtensions) {
          id
          label
          info
          travelExtension @include(if: $withPricingTravelsExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withPricingTravelsExtensionsAccommodationMapItems) {
            id
          }
        }
        personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
          mandatorySettings @include(if: $withPricingTravelsPersonalDiscountsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        importDateTime
        importStatus
      }
    }
  }`

// language=GraphQL
export const DELETE_FIELD_VISIBILITY_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteCustomBookingFormFieldVisibilityConfigInput) {
    deleteCustomBookingFormFieldVisibilityConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_FIELD_VISIBILITY_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteCustomBookingFormFieldVisibilityConfigInput) {
    forceDeleteCustomBookingFormFieldVisibilityConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_FIELD_VISIBILITY_CONFIG_PRICING_TRAVELS_MUTATION = `
  mutation Mutation($input: addCustomBookingFormFieldVisibilityConfigPricingTravelsInput) {
    addCustomBookingFormFieldVisibilityConfigPricingTravels(input: $input) {
      id
      pricingTravelIds
    }
  }`

// language=GraphQL
export const REMOVE_FIELD_VISIBILITY_CONFIG_PRICING_TRAVELS_MUTATION = `
  mutation Mutation($input: removeCustomBookingFormFieldVisibilityConfigPricingTravelsInput) {
    removeCustomBookingFormFieldVisibilityConfigPricingTravels(input: $input) {
      id
      pricingTravelIds
    }
  }`

// language=GraphQL
export const CREATE_FIELD_VISIBILITY_CONFIG_PRICING_TRAVELS_MUTATION = `
  mutation Mutation($input: createCustomBookingFormFieldVisibilityConfigPricingTravelsInput) {
    createCustomBookingFormFieldVisibilityConfigPricingTravels(input: $input) {
      id
      pricingTravelIds
    }
  }`

// language=GraphQL
export const DELETE_FIELD_VISIBILITY_CONFIG_PRICING_TRAVELS_MUTATION = `
  mutation Mutation($input: deleteCustomBookingFormFieldVisibilityConfigPricingTravelsInput) {
    deleteCustomBookingFormFieldVisibilityConfigPricingTravels(input: $input) {
      id
      pricingTravelIds
    }
  }`

// language=GraphQL
export const FIELD_VISIBILITY_CONFIGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withCustomBookingFormFields: Boolean = false) {
  groupedDependents: customBookingFormFieldVisibilityConfigDependents(id: $id) {
    customBookingFormFields @include(if: $withCustomBookingFormFields) {
      id
      inputType
      name
      label
      info
      value
      required
    }
  }
}`
